<template>
  <svg :class="className" :width="width" :height="height" :viewBox="viewBox" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 982">
    <rect id="Rectangle" opacity="0.7" x="5.68347" y="3.60251" width="2.63939" height="7.97223" rx="1.31969" fill="currentColor"/>
    <path id="Combined Shape" fill-rule="evenodd" clip-rule="evenodd" d="M0.459775 8.36229C1.07195 8.97382 2.06382 8.97375 2.67591 8.36214L7.00069 4.0407L11.3253 8.36198C11.9374 8.97359 12.9293 8.97367 13.5415 8.36214C14.1544 7.74982 14.1545 6.75638 13.5416 6.14397L8.27754 0.883986C7.92828 0.534993 7.45536 0.385116 6.99989 0.434364C6.54486 0.385589 6.07258 0.535517 5.72368 0.884141L0.459616 6.14413C-0.153267 6.75654 -0.153196 7.74997 0.459775 8.36229Z" fill="currentColor"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ReactivationsIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '12',
    },
    viewBox: {
      type: String,
      default: '0 0 14 12',
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
};
</script>
